import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL || (
  process.env.NODE_ENV === "development"
    ? `${window.location.protocol}//${window.location.hostname}:8000`
    : window.location.origin
);
const API = `${backendUrl}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const formatErr = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join("، ");
  return e?.message || "حدث خطأ غير متوقع";
};

export default api;
